import React from 'react'
import logo from '../assets/logo.svg';

function ReactCover() {
  return (
    <div>
      <div className="App">
        <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <p>
            Page not Found
            </p>
            <a
            className="App-link"
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            >
            Home
            </a>
        </header>
          </div>
    </div>
  )
}

export default ReactCover;